import { useQuery } from '@tanstack/react-query';
import {
  getSectorIntelFilterOptions,
  getSectorIntelList,
} from '../../api/sectorIntelApi';
import type {
  SectorIntelFilters,
  SectorIntelFilterOptions,
  SectorIntelListResponse,
} from './sectorIntel.types';

const QK_LIST = 'sector-intel-list';
const QK_OPTIONS = 'sector-intel-filter-options';

export function useSectorIntelList(filters: SectorIntelFilters) {
  return useQuery<SectorIntelListResponse>({
    queryKey: [QK_LIST, filters],
    queryFn: () => getSectorIntelList(filters),
    staleTime: 30_000,
  });
}

export function useSectorIntelFilterOptions() {
  return useQuery<SectorIntelFilterOptions>({
    queryKey: [QK_OPTIONS],
    queryFn: () => getSectorIntelFilterOptions(),
    staleTime: 5 * 60_000,
  });
}
